import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { Stack } from 'components/stack/stack';

const TextWrapper = styled.div`
  ${tw`flex justify-center items-center`}
`;
export const SubjectIcon: React.FC<{
  icon: string | undefined;
  text: string;
  isTextSafeAsHTML?: boolean;
}> = ({ icon, text, isTextSafeAsHTML = false }) => {
  return (
    <Stack
      gap={0.5}
      flow="row"
      alignItems="center"
      justifyItems="center"
      style={{ width: '107px' }}
    >
      <div>
        <CustomIcon height={40} src={icon} />
      </div>
      <div style={{ height: '60px', width: '80px' }}>
        {isTextSafeAsHTML ? (
          <TextWrapper style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }}></TextWrapper>
        ) : (
          <TextWrapper style={{ textAlign: 'center' }}>{text}</TextWrapper>
        )}
      </div>
    </Stack>
  );
};
